import React from 'react';
import { DropdownButton } from '../DropdownButton/DropdownButton';
import { IconProps } from '../../icons';
import './NavigationItemDropdown.css';

export interface NavigationItemDropdownProps {
  children: React.ReactNode;
  leadingVisual?: IconProps['name'] | React.ReactNode;
  dropdownContent: React.ReactNode;
  isActive?: boolean;
  variant?: 'primary' | 'secondary' | 'transparent' | 'link';
  disabled?: boolean;
  className?: string;
}

export const NavigationItemDropdown = React.memo(function NavigationItemDropdown({
  children,
  leadingVisual,
  dropdownContent,
  isActive = false,
  variant = 'transparent',
  disabled = false,
  className = '',
}: NavigationItemDropdownProps) {
  const itemClassName =
    `navigation-item-dropdown ${isActive ? 'navigation-item-dropdown--active' : ''} ${className}`.trim();

  return (
    <li className={itemClassName}>
      <DropdownButton variant={variant} disabled={disabled} dropdownContent={dropdownContent}>
        {leadingVisual && typeof leadingVisual === 'string' ? (
          <span className="navigation-item-dropdown__content">
            <span className="navigation-item-dropdown__icon">{leadingVisual}</span>
            {children}
          </span>
        ) : (
          <span className="navigation-item-dropdown__content">
            {leadingVisual}
            {children}
          </span>
        )}
      </DropdownButton>
    </li>
  );
});
